export default "__VITE_ASSET__Cd0n1e5$__"